var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5742 2.90859C18.9132 2.81014 19.3917 2.70266 19.8733 2.86354C20.4695 3.06271 20.9373 3.53058 21.1365 4.12678C21.2974 4.60836 21.1899 5.08688 21.0915 5.42581C20.9884 5.78077 20.8174 6.21874 20.6219 6.71976L15.9934 18.5802C15.7755 19.1387 15.5881 19.619 15.4107 19.9778C15.2465 20.3097 14.9861 20.7721 14.509 21.02C13.9303 21.3206 13.2413 21.3202 12.6629 21.0189C12.1861 20.7705 11.9262 20.3078 11.7625 19.9756C11.5855 19.6167 11.3987 19.1362 11.1814 18.5774L9.66464 14.6771C9.61432 14.5477 9.58887 14.483 9.56831 14.4369L9.56673 14.4333L9.56319 14.4317C9.51702 14.4112 9.45231 14.3857 9.32291 14.3354L5.42266 12.8187C4.86388 12.6014 4.38339 12.4145 4.02445 12.2376C3.69229 12.0738 3.22959 11.8139 2.98118 11.3372C2.67983 10.7588 2.67943 10.0698 2.9801 9.49102C3.22794 9.01396 3.69034 8.75352 4.0223 8.58938C4.38104 8.41199 4.86131 8.22459 5.41984 8.00666L17.2803 3.3782C17.7813 3.18264 18.2193 3.0117 18.5742 2.90859Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationArrow);
export default __webpack_public_path__ + "static/media/location-arrow.623f61db90fff15ad5abd37703702942.svg";
export { ForwardRef as ReactComponent };